import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { IoClose } from "react-icons/io5";
import { RxHamburgerMenu } from "react-icons/rx";
import logo from "../assets/logo/logo.png";

function Navbar() {

    const [isVisible, setIsVisible] = useState(true);
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [menuTransition, setMenuTransition] = useState(false);
    const [hideLink, setHideLink] = useState(false);
    //const [negativeClass, setNegativeClass] = useState('text-negative');

    const location = useLocation();
    const isActive = (path) => location.pathname === path;

    // const lastScrollY = useRef(window.scrollY);
    
    // useEffect(() => {
    //     const handleScroll = () => {
    //         const isSmallDevice = window.innerWidth < 768;

    //         if (!isMenuOpen) {
    //             setIsVisible(window.scrollY < lastScrollY.current);
    //             lastScrollY.current = window.scrollY;
    //         }

    //         if (window.scrollY < 800) {
    //             setIsVisible(true);
    //         }

    //         if ((window.scrollY > 850 && !isSmallDevice) || (window.scrollY > 710 && isSmallDevice)) {
    //             setNegativeClass('text-negative');
    //         }
    //     };

    //     window.addEventListener('scroll', handleScroll, { passive: true });

    //     return () => window.removeEventListener('scroll', handleScroll);
    // }, [isMenuOpen]);

    useEffect(() => {
        document.body.style.overflow = isMenuOpen ? 'hidden' : 'auto';
    }, [isMenuOpen]);


    const handleMenuOpen = () => {
        setIsMenuOpen(true);
        setHideLink(false);
        setTimeout(() => {
            setMenuTransition(true);
        }, 500);
    };

    const handleMenuClose = () => {
        setHideLink(true);
        setTimeout(() => {
            setMenuTransition(false);
            setIsMenuOpen(false);
        }, 450);
    };

    return (
    <>
        <div className={`mix-blend-difference text-white hidden xl:block fixed z-50 top-0 left-0 w-full transition-transform duration-300 ${isVisible ? 'translate-y-0' : '-translate-y-full'}`}>
            <div className={`bg-transparent flex xl:justify-center justify-end items-center p-10`}>
                
                <nav className={`flex justify-end items-center`}>
                    <Link to="/" className={`uppercase panoragraf-light mx-6 ${isActive('/') ? 'underline-animate-active' : 'underline-animate'}`}>Home</Link>
                    <Link to="/staff/" className={`uppercase panoragraf-light mx-6 ${isActive('/staff/') ? 'underline-animate-active' : 'underline-animate'}`}>Chi siamo</Link>
                    <Link to="/fisioterapia/" className={` uppercase panoragraf-light mx-6 ${isActive('/fisioterapia/') ? 'underline-animate-active' : 'underline-animate'}`}>fisioterapia</Link>
                    <Link to="/formazione/" className={`uppercase panoragraf-light mx-6 ${isActive('/formazione/') ? 'underline-animate-active' : 'underline-animate'}`}>formazione</Link>
                    <Link to="/tecnologie/" className={`uppercase panoragraf-light mx-6 ${isActive('/tecnologie/') ? 'underline-animate-active' : 'underline-animate'}`}>tecnologie</Link>
                    <Link to="/servizi/" className={`uppercase panoragraf-light mx-6 ${isActive('/servizi/') ? 'underline-animate-active' : 'underline-animate'}`}>servizi</Link>
                </nav>
                
            </div>
        </div>

        <div className={`block xl:hidden fixed z-50 top-0 left-0 w-full transition-transform duration-300 ${isVisible ? 'translate-y-0' : '-translate-y-full'}`}>
            <div className={`flex xl:justify-center justify-end items-center text-white p-10`}>
                
                    <button className="w-6 h-6" onClick={handleMenuOpen}>
                        <RxHamburgerMenu className='text-3xl text-mcare'/>
                    </button>
                    <nav className={`z-50 flex flex-col justify-top items-center absolute top-0 right-0 w-full h-full bg-black transition-all duration-[500ms] ease-in ${isMenuOpen ? 'opacity-100' : 'opacity-0'} ${isMenuOpen ? 'translate-y-0' : '-translate-y-full'} ${isMenuOpen && 'h-screen'}`}>
                        {menuTransition && (
                            <>
                                <Link to="/" data-aos="fade-right" data-aos-duration="250" className={`${hideLink ? 'link-hidden' : ''} text-white uppercase mx-6 mb-2 mt-36 ${isActive('/') ? 'text-mcare' : ''}`}>Home</Link>
                                <Link to="/staff/" data-aos="fade-right" data-aos-duration="500" className={`${hideLink ? 'link-hidden' : ''} text-white uppercase mx-6 my-2 ${isActive('/staff/') ? 'text-mcare' : ''}`}>chi siamo</Link>
                                <Link to="/fisioterapia/" data-aos="fade-right" data-aos-duration="750" className={`${hideLink ? 'link-hidden' : ''} text-white uppercase mx-6 my-2 ${isActive('/fisioterapia/') ? 'text-mcare' : ''}`}>fisioterapia</Link>
                                <Link to="/formazione/" data-aos="fade-right" data-aos-duration="1000" className={`${hideLink ? 'link-hidden' : ''} text-white uppercase mx-6 my-2 ${isActive('/formazione/') ? 'text-mcare' : ''}`}>Formazione</Link>
                                <Link to="/tecnologie/" data-aos="fade-right" data-aos-duration="1250" className={`${hideLink ? 'link-hidden' : ''} text-white uppercase mx-6 my-2 ${isActive('/tecnologie/') ? 'text-mcare' : ''}`}>Tecnologie</Link>
                                <Link to="/servizi/" data-aos="fade-right" data-aos-duration="1500" className={`${hideLink ? 'link-hidden' : ''} text-white uppercase mx-6 my-2 ${isActive('/servizi/') ? 'text-mcare' : ''}`}>Servizi</Link>
                                <button className="absolute top-0 right-0 w-6 h-6 text-white m-10" onClick={handleMenuClose}>
                                    <IoClose className='text-3xl text-mcare'/>
                                </button>
                                <img src={logo} alt="Logo" className="w-40 h-fit mt-20" data-aos="fade-in" data-aos-delay="800"/>
                            </>
                        )}
                        
                    </nav>
                
            </div>
        </div>
    </>
    );
}

export default Navbar;
